import { useState, useContext } from 'react';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import { BluebookContext } from 'chameleon/packages/blue-book-player/state/BluebookContext';
import { SET_IS_ANNOTATION_ENABLED } from 'chameleon/packages/blue-book-player/state/reducer';

const useToggleAnnotation = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const playerEl = useGetPlayerEl();
  const { dispatch } = useContext(BluebookContext);

  const toggleAnnotation = () => {
    const newIsEnabled = !isEnabled;

    playerEl.classList.toggle('with-annotation', newIsEnabled);

    setIsEnabled(newIsEnabled);
    dispatch({ type: SET_IS_ANNOTATION_ENABLED, payload: newIsEnabled });
  };

  return {
    toggleAnnotation,
  };
};

export default useToggleAnnotation;
